import React, {useState} from 'react';
import {InputNumber} from "antd";
import {decimalToCentsNoRound, formatCurrency} from "../../utils/monetary";

function InputNumberFormated({value, onChange, onBlur,asZero, asNegative, ...props}) {
	const [isEditing, setIsEditing] = useState(false);

	// On convertit en euros seulement si c'est un entier (centimes)
	// Si c'est déjà un décimal, on considère qu'il est déjà en euros.
	const displayValue = (value !== null && value !== undefined && Number.isInteger(value)) ? value / 100 : value;

	const handleChange = (newValue) => {
		if (onChange) {
			// On renvoie la valeur convertie en centimes au parent (Form.Item)
			// Utilisation de decimalToCentsNoRound pour éviter les problèmes de flottants
			onChange(decimalToCentsNoRound(newValue));
		}
	}

	return (
		<InputNumber
			{...props}
			value={displayValue}
			onChange={handleChange}
			onFocus={(e) => {
				setIsEditing(true);
				setTimeout(() => {
					e.target.select();
				}, 0);
			}}
			formatter={(val) => {
				if (isEditing){
					// Formatage simple avec espaces pour les milliers pendant l'édition
					return `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
				}
				// Affichage complet "1 234,56 €" quand on n'édite pas
				// Note: on utilise decimalToCentsNoRound car formatCurrency attend des centimes
				// Autorise l'affichage de "0,00 €" si asZero est vrai
				if (asNegative || (val > 0 || (asZero && (val === 0 || val === '0'))) ) {
					return formatCurrency(decimalToCentsNoRound(val));
				}
				return '';
			}}
			parser={(val) => {
				return val.replace(/\s/g, '').replace(',', '.');
			}}
			onBlur={(e) => {
				setIsEditing(false);
				if (onBlur) onBlur(e);
			}}
			precision={2}
			min={asNegative ? Number.MIN_SAFE_INTEGER : 0}
			step={0.01}
			controls={false}
		/>
	);
}

export default InputNumberFormated;